import { UserLightResponse } from "./user";

export interface DevelopmentRequestResponse {
  id: number;
  title: string;
  description: string;
  audience: "internal" | "external";
  departments: string[];
  needsErpIntegration: boolean;
  responsibleDepartment: "integrations" | "software_development" | "ict" | null;
  estimateDays: number | null;
  internalNotes: string | null;
  status: "draft" | "new" | "in_progress" | "completed";
  approvedBy: UserLightResponse | null;
  approvedAt: string | null;
  participants: UserLightResponse[];
  createdBy: UserLightResponse;
  createdAt: string;
  updatedBy: UserLightResponse | null;
  updatedAt: string;
  supervisor: UserLightResponse | null;
}

export interface CreateDevelopmentRequestRequest {
  title: string;
  description: string;
  audience: "internal" | "external";
  departments?: string[];
  needsErpIntegration: boolean;
  participantIds: string[];
}

export interface UpdateDevelopmentRequestRequest {
  title?: string;
  description?: string;
  audience?: "internal" | "external";
  departments?: string[];
  needsErpIntegration?: boolean;
  participantIds?: string[];
  responsibleDepartment?: "integrations" | "software_development" | "ict";
  estimateDays?: number;
  internalNotes?: string;
  status?: "draft" | "new" | "in_progress" | "completed";
  supervisorId?: string;
}

export function statusLabel(status: DevelopmentRequestResponse["status"], t: (k: string) => string) {
  const map: Record<DevelopmentRequestResponse["status"], string> = {
    draft: t("requests.statusDraft"),
    new: t("requests.statusNew"),
    in_progress: t("requests.statusInProgress"),
    completed: t("requests.statusCompleted"),
  };
  return map[status];
}
